var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loaded)?_c('MainPage',{attrs:{"open-article":true,"shuffle-articles":true}},[_c('ArticleSearchOnPage',{attrs:{"genres":_vm.genres,"schools":_vm.schools}})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }